import React, { Component } from 'react';
import SearchBar from '../CommonComponents/SearchBar';
import { getImage, api } from '../utils';
import { botID, ALL_ACTIONS } from '../constants';
import { AppContext } from '../Context';
import WebsChannel from '../assets/icons/webs_channel.svg';
import WhatsappChannel from '../assets/icons/whatsapp_channel.png';
import Availability from '../assets/icons/availability.svg';
import UnAvailability from '../assets/icons/un-availability.svg';
import CloseBtn from '../assets/icons/close-file-upload-status.svg';
import Loader from '../assets/icons/loader.svg';

type Props = {
  sessionID: string;
  userDetails: any;
  toasterNotifier: Function;
  isEndedChatsSelected: boolean;
  isBotChatsSelected: boolean;
  getGroupingFormatDate: Function;
  //  chatChangeAvailable:Function;
  isUserDetailsLoading: boolean;
  noChatsSelected: boolean;
  type: string;
};
type State = {
  searchTerm: string;
  relatedQuestion: string;
  shwKBotPannel: boolean;
  shwUserDetailsPannel: boolean;
  userName: string;
  userEmail: string;
  userContactNo: string;
  userSource: string;
  deviceInfo: string;
  feedbackComment: string;
  time: string;
  // setAvailability: boolean;
  // mouseOverFunc: boolean;
  // shwAgentPopup: boolean;
};

export default class KnowledgePanel extends Component<Props, State> {
  static contextType = AppContext;
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    // this.setAgentAvailability = this.setAgentAvailability.bind(this);
  }

  setInitialState(): State {
    return {
      searchTerm: '',
      relatedQuestion: '',
      shwKBotPannel: false,
      shwUserDetailsPannel: true,
      userName: '',
      userEmail: '',
      userContactNo: '',
      userSource: '',
      // setAvailability: false,
      // mouseOverFunc: false,
      // shwAgentPopup: true,
      deviceInfo: '',
      feedbackComment: '',
      time: '',
    };
  }

  fetchRelatedQuestions = (searchTerm: string) => {
    // 'gOkt1v0dxPMbh4h5dh6sSw=='   //hyriduat
    //mKB1bkbbRVHn2NFQnDmK/g==
    let agentId = sessionStorage.getItem('agentId');
    api(
      `getEvaResponse?query=${searchTerm}&botId=${encodeURIComponent(
        'mKB1bkbbRVHn2NFQnDmK/g=='
      )}&loggedInAgentId=${agentId}&agentSessionID=${sessionStorage.getItem(
        'agentActiveSession'
      )}`
    ).then((response) => {
      this.setState({
        relatedQuestion: response.answer,
      });
    });
  };

  // setAgentAvailability = (val: boolean) => {

  //   api(`markAgentAvailibility`, 'POST', {
  //     loggedInAgentId: sessionStorage.getItem('agentId'),
  //     isAgentAvailable: val,
  //   }).then((res) => {
  //     api(
  //       `getMarkedAgentAvailibility?loggedInAgentId=${sessionStorage.getItem('agentId')}`
  //     ).then((res) => {

  //       this.setState(
  //         {
  //           setAvailability: res.status,
  //           shwAgentPopup: false,
  //         },
  //         () => {
  //           this.props.chatChangeAvailable(val);
  //           if (res.status === true) {
  //             this.props.toasterNotifier('Changed your status to ‘available’');
  //           } else {
  //             this.props.toasterNotifier('Changed your status to ‘unavailable’');
  //           }
  //         }
  //       );
  //     });
  //   });
  // };

  relatedQues = (searchTerm: string) => {
    return (
      <div className='related-question'>
        <div className='rq-header'>{`Questions related to '${searchTerm}'`}</div>
        <div className='rq-content-wrapper'>
          <img src={getImage('message.svg')} alt='message' height='15px' width='15px' />
          <span
            className='rq-content clickable'
            dangerouslySetInnerHTML={{ __html: this.state.relatedQuestion }}
            onClick={(event: any) => {
              this.context.dispatch({
                type: ALL_ACTIONS.UPDATE_INPUT_STATE,
                payload: event.target && event.target.innerText,
              });
            }}></span>
        </div>
      </div>
    );
  };

  // agentAvailability = () => {
  //   if(sessionStorage.getItem('roleId') !== '1'){
  //   return (
  //     <div className='agent-availability-wrapper'>
  //       <div
  //         className={
  //           this.state.shwAgentPopup &&  this.state.setAvailability === false
  //             ? 'test agent-availability-icon'
  //           //  : 'agent-availability-icon'
  //             :  this.state.shwAgentPopup && this.state.setAvailability === true
  //             ? 'un-test agent-availability-icon'
  //             : 'agent-availability-icon'
  //         }
  //         style={
  //           this.state.setAvailability === false
  //             ? {padding: '12px'}
  //             : this.state.mouseOverFunc
  //             // ? { backgroundColor: '#1fc7aa', padding: '0px 2px 0px 7px', width: '140px' }
  //             ? { backgroundColor: '#1fc7aa', padding: '12px'}
  //             : { backgroundColor: '#1fc7aa', padding: '12px' }
  //         }
  //         onClick={() => {
  //           this.setState({
  //             shwAgentPopup: true,
  //           });
  //         }}
  //         onMouseOver={() => {
  //           this.setState({
  //             mouseOverFunc: true,
  //           });
  //         }}
  //         onMouseLeave={() => {
  //           this.setState({
  //             mouseOverFunc: false,
  //           });
  //         }}>
  //         <img
  //           src={this.state.setAvailability === false ? UnAvailability : Availability}
  //           alt='Availability'
  //           onClick={() => {
  //             this.setState({
  //               setAvailability: true,
  //             });
  //           }}
  //         />
  //         <div
  //           className='availabilty-msg'
  //           style={
  //             this.state.setAvailability === true && this.state.shwAgentPopup === true
  //               ? { color: 'white', display: 'block' }
  //               : this.state.setAvailability === true
  //               ? { color: 'white' }
  //               : this.state.shwAgentPopup
  //               ? { display: 'block' }
  //               : {}
  //           }
  //          >
  //           {this.state.setAvailability === false ? <>UNAVAILABLE</> : <>AVAILABLE</>}
  //         </div>
  //       </div>

  //       {this.state.setAvailability === false
  //         ? this.state.shwAgentPopup === true && (
  //             <div className='agent-availability-popup'>
  //               <div className='agent-availability-popup-close'>
  //                 <img
  //                   src={CloseBtn}
  //                   alt=''
  //                   className='agent-availability-close-icon'
  //                   onClick={() => {
  //                     this.setState({
  //                       shwAgentPopup: false,
  //                     });
  //                   }}
  //                 />
  //               </div>
  //               <div className='agent-status-msg'>
  //                 Your status is set to ‘unavailable’.
  //               </div>
  //               <div
  //                 className='set-agent-availability'
  //                 onClick={() => {
  //                   this.setAgentAvailability(true);
  //                 }}>
  //                 SET TO AVAILABLE
  //               </div>
  //             </div>
  //           )
  //         : this.state.shwAgentPopup && (
  //             <div className='agent-availability-popup'>
  //               <div className='agent-availability-popup-close'>
  //                 <img
  //                   src={CloseBtn}
  //                   alt=''
  //                   className='agent-availability-close-icon'
  //                   onClick={() => {
  //                     this.setState({
  //                       shwAgentPopup: false,
  //                     });
  //                   }}
  //                 />
  //               </div>
  //               <div className='agent-status-msg'>Your status is set to ‘available’.</div>
  //               <div
  //                 className='set-agent-availability'
  //                 onClick={() => {
  //                   this.setAgentAvailability(false);
  //                 }}>
  //                 SET TO UNAVAILABLE
  //               </div>
  //             </div>
  //           )}
  //     </div>
  //   );
  //               }
  // };
  userDetailsPannel = () => {
    return (
      <div className='user-details-wrapper'>
        {this.props.isUserDetailsLoading ? (
          <div
            className='userdetails-loader'
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              width: '100%',
              height: 'calc(97vh - 167px)',
              flexDirection: 'column',
            }}>
            <img src={Loader} alt='loader' className='loader-icon' />
            <span className='loader-content'>Loading details</span>
          </div>
        ) : null}
        {this.props.isUserDetailsLoading === false && this.props.userDetails.userName ? (
          <div>
            <div className='user-title'>USER</div>
            <div className='user-val'>{this.props.userDetails.userName}</div>
          </div>
        ) : null}
        {this.props.isUserDetailsLoading === false && this.props.userDetails.userEmail ? (
          <div style={{ marginTop: '12px' }}>
            <div className='user-title'>EMAIL</div>
            <div className='user-val'>{this.props.userDetails.userEmail}</div>
          </div>
        ) : null}
        {this.props.isUserDetailsLoading === false &&
        this.props.userDetails.userContact ? (
          <div style={{ marginTop: '12px' }}>
            <div className='user-title'>PHONE</div>
            <div className='user-val'>{this.props.userDetails.userContact}</div>
          </div>
        ) : null}
        {this.props.isUserDetailsLoading === false &&
        this.props.userDetails.userSource ? (
          <div style={{ marginTop: '12px' }}>
            <div className='user-title'>SOURCE</div>
            <div className='user-val' style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={
                  this.props.userDetails.userSource === 'webs'
                    ? WebsChannel
                    : this.props.userDetails.userSource === 'whatsapp' ||
                      this.props.userDetails.userSource === 'WhatsApp'
                    ? WhatsappChannel
                    : ''
                }
                alt=''
                style={{ width: '20px', height: '20px' }}
              />
              <span style={{ marginLeft: '8px' }}>
                {/* {this.props.userDetails.userSource} */}
                {!this.props.isUserDetailsLoading &&
                this.props.userDetails.userSource === 'webs' &&
                (this.props.userDetails.deviceInfo === null ||
                  this.props.userDetails.deviceInfo === '')
                  ? 'Web'
                  : this.props.userDetails.userSource === 'webs'
                  ? `Web (${this.props.userDetails.deviceInfo})`
                  : this.props.userDetails.userSource === 'whatsapp'
                  ? 'WhatsApp'
                  : this.props.userDetails.userSource}
              </span>
            </div>
          </div>
        ) : null}

        {this.props.isUserDetailsLoading === false &&
        this.props.isEndedChatsSelected &&
        this.props.userDetails.sessionId ? (
          <div style={{ marginTop: '12px' }}>
            <div className='user-title'>SESSION ID</div>
            <div className='user-val'>{this.props.userDetails.sessionId}</div>
          </div>
        ) : null}
        {this.props.isUserDetailsLoading === false &&
        this.props.isEndedChatsSelected &&
        this.props.userDetails.time ? (
          <div style={{ marginTop: '12px' }}>
            <div className='user-title'>DATE</div>
            <div className='user-val'>
              {this.props.getGroupingFormatDate(this.props.userDetails.time, '')}
            </div>
          </div>
        ) : null}
        {this.props.isUserDetailsLoading === false &&
        this.props.isEndedChatsSelected &&
        this.props.userDetails.feedbackComment ? (
          <div
            style={{
              marginTop: '12px',
              overflow: 'auto',
              overflowY: 'scroll',
              overflowX: 'hidden',
            }}>
            <div className='user-title'>FEEDBACK COMMENT</div>
            <div className='user-val'>{this.props.userDetails.feedbackComment}</div>
          </div>
        ) : null}

        {/* {this.agentAvailability()} */}
      </div>
    );
  };
  knowledgeBot = () => {
    return (
      <div className='knowledge-panel-content'>
        <div className='search-wrapper'>
          <SearchBar
            placeholder='Search knowledge bot'
            onEnter={(term: any) => {
              this.setState({
                searchTerm: term,
              });
              this.fetchRelatedQuestions(term);
            }}
            icon='submit'
            value={this.state.searchTerm}
          />
        </div>
        {this.state.searchTerm ? this.relatedQues(this.state.searchTerm) : null}
        {/* {this.agentAvailability()} */}
      </div>
    );
  };
  componentDidMount() {
    window.addEventListener('message', (event) => {
      if (event.data && event.data.source === 'chat') {
        this.setState({
          searchTerm: event.data.message,
        });
      }
    });
    // api(
    //   `getMarkedAgentAvailibility?loggedInAgentId=${sessionStorage.getItem('agentId')}`
    // ).then((res) => {
    //   this.setState({
    //     setAvailability: res.status,
    //   });
    // });
  }
  componentDidUpdate(prevProps: Props, prevState: State) {
    //  console.log(prevProps.userDetails.userName,this.props.userDetails.userName);
    if (
      prevProps.userDetails !== this.props.userDetails ||
      prevState.userName !== this.state.userName
    ) {
      this.setState({
        userName: this.props.userDetails.userName,
        userEmail: this.props.userDetails.userEmail,
        userContactNo: this.props.userDetails.userContact,
        userSource: this.props.userDetails.userSource,
      });
    }
    // if(prevState.userName !== this.state.userName){
    //   // console.log(this.props.userDetails)
    //   this.setState({
    //     userName: this.props.userDetails.userName,
    //     userEmail: this.props.userDetails.userEmail,
    //     userContactNo: this.props.userDetails.userContact,
    //     userSource: this.props.userDetails.userSource,
    //   });
    // }
  }
  render() {
    return (
      <div
        className={`knowledge-panel-wrapper${
          this.props.noChatsSelected === true ||
          (!this.props.type &&
            this.props.isEndedChatsSelected !== true &&
            this.props.isBotChatsSelected !== true)
            ? ' hidden'
            : ''
        }`}>
        <div className='header'>
          <div
            className='panel'
            onClick={() => {
              this.setState({
                shwKBotPannel: false,
                shwUserDetailsPannel: true,
              });
            }}
            style={
              this.state.shwUserDetailsPannel
                ? { color: '#6c7ef2', borderBottom: '2px solid #6c7ef2' }
                : {}
            }>
            User & Chat details
          </div>
          <div
            className='panel'
            onClick={() => {
              this.setState({
                shwKBotPannel: true,
                shwUserDetailsPannel: false,
              });
            }}
            style={
              this.state.shwKBotPannel
                ? { color: '#6c7ef2', borderBottom: '2px solid #6c7ef2' }
                : {}
            }>
            Knowledge Bot
          </div>
        </div>
        {this.state.shwKBotPannel && this.knowledgeBot()}
        {this.state.shwUserDetailsPannel && this.userDetailsPannel()}
      </div>
    );
  }
}
